interface ShouldShowFullscreenButtonParams {
    isFullscreenButtonAvailable: boolean;
    isMeetingFullscreenEnabled: boolean;
    isScreenSharing: boolean;
}

export const shouldShowFullscreenButton = ({
    isFullscreenButtonAvailable,
    isMeetingFullscreenEnabled,
    isScreenSharing,
}: ShouldShowFullscreenButtonParams) => {
    if (!isFullscreenButtonAvailable) {
        return false;
    }

    if (isMeetingFullscreenEnabled) {
        return false;
    }

    if (isScreenSharing) {
        return true;
    }

    return false;
};
